import { render } from "./AboutSwiperComponent.vue?vue&type=template&id=61593063&scoped=true"
import script from "./AboutSwiperComponent.vue?vue&type=script&lang=js"
export * from "./AboutSwiperComponent.vue?vue&type=script&lang=js"

import "./AboutSwiperComponent.vue?vue&type=style&index=0&id=61593063&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61593063"]])

export default __exports__